// Expose public Images/card assets as module exports using PUBLIC_URL
// This avoids bundling the binary files into src but makes components import
// stable URLs that work in production regardless of the hosting subpath.

const base = process.env.PUBLIC_URL + '/Images/card';

export const mess = `${base}/mess.jpeg`;
export const canteen = `${base}/canteen.jpg`;
export const sports = `${base}/sports.jpg`;
export const laundry = `${base}/laundry.jpg`;
export const jbclub = `${base}/jbclub.JPG`;
export const hero = `${base}/hero.JPG`;
export const GYM = `${base}/GYM.jpg`;

// Vector/icon images
export const diet1 = `${base}/diet 1.png`;
export const restaurant1 = `${base}/restaurant 1.png`;
export const sports1 = `${base}/sports 1.png`;
export const laundryMachine1 = `${base}/laundry-machine 1.png`;
export const snooker1 = `${base}/snooker 1.png`;
export const accomodation1 = `${base}/accomodation 1.png`;
export const weights1 = `${base}/weights 1.png`;

export default {
  mess,
  canteen,
  sports,
  laundry,
  jbclub,
  hero,
  GYM,
  diet1,
  restaurant1,
  sports1,
  laundryMachine1,
  snooker1,
  accomodation1,
  weights1,
};
